var __jsx = React.createElement;
import React, { createContext, useContext, useReducer } from 'react';
import { DEFAULT_STATE, filtersReducer } from '../localReducers';
import { jsx as _jsx } from "react/jsx-runtime";
var CONTEXT = /*#__PURE__*/createContext([DEFAULT_STATE, function () {
  return null;
}]);
export var FiltersProvider = function FiltersProvider(_ref) {
  var children = _ref.children;
  var value = useReducer(filtersReducer, DEFAULT_STATE); // use reducer and stuff

  return /*#__PURE__*/_jsx(CONTEXT.Provider, {
    value: value,
    children: children
  });
};
export var useFiltersState = function useFiltersState() {
  return useContext(CONTEXT);
};